import { render, staticRenderFns } from "./selectDesc.vue?vue&type=template&id=a90ae61e&scoped=true"
import script from "./selectDesc.vue?vue&type=script&lang=js"
export * from "./selectDesc.vue?vue&type=script&lang=js"
import style0 from "./selectDesc.vue?vue&type=style&index=0&id=a90ae61e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ae61e",
  null
  
)

export default component.exports